<template>
  <div>
    hiiiiii
    <v-btn @click="$router.push('/test/termUse')">click</v-btn>
  </div>
</template>
